import MainLayout from "../../Layouts/Main/main";
import { CreateModule } from "../factory";
import navigation from "./navigations.js";

const Miscellaneous = ({ baseUrl }) =>
  CreateModule({ baseUrl, navigation, layout: MainLayout });

export default Miscellaneous;
